import { ActivityIndicator } from "react-native"

export const StyledLoader = ActivityIndicator
